import { getTruthyValue } from "@draftkings/sportsbook-common-utils";
import { parseSettlementStatus } from "../parseSettlementStatus";
import { parseEvent } from "../parseEvent";
import { parsePointsMetaData } from "../parsePointsMetadata";
import { safeString } from "../../helpers";
import { isSettledStatus } from "../../helpers";
import { parseTagsSelection } from "../parseTags";
import { EETAG } from "../../constants";
import { conditionalValue } from "../../helpers";
const shouldBuildSelectionParsing = (event, selection) => typeof event !== "undefined" || selection.eventId === "0";
const shouldIncludeEvent = (isAllEventTheSame, isLastInEventGroup, beEvent) => (isAllEventTheSame || isLastInEventGroup) && (beEvent === null || beEvent === void 0 ? void 0 : beEvent.eventId) !== "0";
export function parseSelection(selection, events, teamLogos, dateFormatter, dict, staticS3Host, swooshFeatureFlag, swooshBaseUrl, isAllEventTheSame, isLastInEventGroup) {
    var _a, _b, _c;
    const beEvent = events.get(selection.eventId);
    if (shouldBuildSelectionParsing(beEvent, selection)) {
        const status = conditionalValue(!!selection.isEarlyExitApplied, "EarlyExit", parseSettlementStatus(selection.settlementStatus));
        const event = beEvent ? parseEvent(beEvent, status, teamLogos, dateFormatter, dict, staticS3Host, swooshFeatureFlag, swooshBaseUrl) : undefined;
        if (shouldBuildSelectionParsing(event, selection)) {
            return {
                type: "regular",
                selectionId: selection.selectionId,
                status,
                displayOdds: safeString(selection.displayOdds),
                event: conditionalValue(shouldIncludeEvent(isAllEventTheSame, isLastInEventGroup, beEvent), event, undefined),
                finalScore: safeString(selection.gameScore),
                marketBlurb: selection.marketBlurb,
                isInBetBoost: selection.isInBetBoost,
                marketDisplayName: safeString(selection.marketDisplayName),
                selectionDisplayName: selection.selectionDisplayName,
                isEarlyWinSettled: selection.isEarlyWinSettled,
                nestedSGPSelections: parseNestedSGPSelections(selection.nestedSGPSelections, dict, events, teamLogos, dateFormatter, staticS3Host, swooshFeatureFlag, swooshBaseUrl, selection.eventId === "0", beEvent),
                legTracking: parsePointsMetaData(Object.assign(Object.assign({}, selection.pointsMetadata), { currentTotalPoints: getTruthyValue((_a = beEvent === null || beEvent === void 0 ? void 0 : beEvent.marketMap) === null || _a === void 0 ? void 0 : _a[selection.marketId], (_b = selection.pointsMetadata) === null || _b === void 0 ? void 0 : _b.currentTotalPoints) }), !isSettledStatus(status)),
                replayData: selection.replayData,
                tag: conditionalValue(!!(((_c = selection.tags) === null || _c === void 0 ? void 0 : _c.includes(EETAG)) || selection.isEarlyExitApplied), parseTagsSelection(selection, dict), undefined),
            };
        }
    }
    return undefined;
}
function parseNestedSGPSelections(nestedSGPSelections, dict, events, teamLogos, dateFormatter, staticS3Host, swooshFeatureFlag, swooshBaseUrl, shouldBuildNestedEvents, parentEvent) {
    if (!(nestedSGPSelections === null || nestedSGPSelections === void 0 ? void 0 : nestedSGPSelections.length)) {
        return undefined;
    }
    return nestedSGPSelections.map((nestedSelection, index, array) => {
        var _a, _b, _c;
        const status = conditionalValue(!!nestedSelection.isEarlyExitApplied, "EarlyExit", parseSettlementStatus(nestedSelection.settlementStatus));
        const beEvent = conditionalValue(shouldBuildNestedEvents, events.get(nestedSelection.eventId), undefined);
        const isLastInEventGroup = index === array.length - 1 || array[index + 1].eventId !== nestedSelection.eventId;
        const nestedEvent = beEvent && isLastInEventGroup
            ? parseEvent(beEvent, status, teamLogos, dateFormatter, dict, staticS3Host, swooshFeatureFlag, swooshBaseUrl)
            : undefined;
        return ({
            type: "nested",
            selectionId: nestedSelection.selectionId,
            status,
            displayOdds: safeString(nestedSelection.displayOdds),
            finalScore: safeString(nestedSelection.gameScore),
            marketBlurb: nestedSelection.marketBlurb,
            isInBetBoost: nestedSelection.isInBetBoost,
            marketDisplayName: safeString(nestedSelection.marketDisplayName),
            selectionDisplayName: nestedSelection.selectionDisplayName,
            event: nestedEvent,
            nestedSGPSelections: undefined,
            isEarlyWinSettled: nestedSelection.isEarlyWinSettled,
            legTracking: parsePointsMetaData(Object.assign(Object.assign({}, nestedSelection.pointsMetadata), { currentTotalPoints: getTruthyValue((_a = parentEvent === null || parentEvent === void 0 ? void 0 : parentEvent.marketMap) === null || _a === void 0 ? void 0 : _a[nestedSelection.marketId], (_b = nestedSelection.pointsMetadata) === null || _b === void 0 ? void 0 : _b.currentTotalPoints) }), !isSettledStatus(parseSettlementStatus(nestedSelection.settlementStatus))),
            tag: conditionalValue(!!(((_c = nestedSelection.tags) === null || _c === void 0 ? void 0 : _c.includes(EETAG)) || nestedSelection.isEarlyExitApplied), parseTagsSelection(nestedSelection, dict), undefined), // the check is for the value 1 since this is the representation of the early exit tag
        });
    });
}
//# sourceMappingURL=parseSelection.js.map